import { render, staticRenderFns } from "./Flash.vue?vue&type=template&id=4d51284c&scoped=true"
import script from "./Flash.vue?vue&type=script&lang=js"
export * from "./Flash.vue?vue&type=script&lang=js"
import style0 from "./Flash.vue?vue&type=style&index=0&id=4d51284c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d51284c",
  null
  
)

export default component.exports